import { Provider } from "@redotech/redo-order-common/provider";
import {
  ProductInfo,
  ProductStatus,
} from "@redotech/redo-product-common/product";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const searchProducts = {
  name: "searchProducts" as const,
  input: z.object({
    searchString: z.string(),
    provider: createEnum(Provider),
    first: z.number().optional(),
    includeStatuses: z.array(createEnum(ProductStatus)).optional(),
    countryCode: z.string().optional(),
  }),
  output: z.object({ products: z.array(ProductInfo) }),
};
